import { parseItemPathForRoutes, toVirtualPath, type MountRoute } from './createFileBrowserProvider';
import { isMountUnavailable, mountHealthMessage } from './fileBrowserMountAccess';

export const JARVIS_COPY_TO = 'jarvisCopyTo';
export const JARVIS_MOVE_TO = 'jarvisMoveTo';

export function isWritableDestinationMount(mount: MountRoute): boolean {
  return mount.mode === 'ReadWrite' && !isMountUnavailable(mount);
}

export function destinationMountDisabledReason(mount: MountRoute): string | null {
  if (isMountUnavailable(mount)) return mountHealthMessage(mount);
  if (mount.mode !== 'ReadWrite') return 'This location is read-only.';
  return null;
}

export function preferredDestinationMount(
  mounts: readonly MountRoute[],
  currentMountId?: string | null
): MountRoute | null {
  const writable = mounts.filter(isWritableDestinationMount);
  return writable.find((mount) => mount.id === currentMountId) ?? writable[0] ?? null;
}

export function transferSelectionLabel(names: readonly string[]): string {
  if (names.length === 1) return names[0] || 'selected item';
  if (names.length > 1) return `${names.length} items`;
  return 'selected items';
}

export function filterTransferableItems<
  T extends { path?: string; key?: string; name: string; dataItem?: unknown }
>(items: readonly T[], routes: readonly MountRoute[]): T[] {
  return items.filter((item) => Boolean(parseItemPathForRoutes(item, routes)?.relative));
}

export function buildDestinationDirectory(mount: MountRoute, relativePath: string): {
  path: string;
  name: string;
  isDirectory: true;
} {
  const relative = relativePath.replace(/^\/+|\/+$/g, '');
  const last = relative.split('/').filter(Boolean).pop();
  return {
    path: toVirtualPath(mount.key, relative),
    name: last || mount.key,
    isDirectory: true
  };
}
